import React from 'react';
import { UserMealsSearchConnectorApollo } from '@front-activerse/common-components';
import UserMealsSearchContainer from './UserMealsSearchContainer';

export const UserMealsSearchPage: React.FC = () => {
  return (
    <UserMealsSearchConnectorApollo>
      {(search) => <UserMealsSearchContainer search={search} />}
    </UserMealsSearchConnectorApollo>
  );
};

export default UserMealsSearchPage;
